// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1nbAT","text":"styles-module__text___1-SpF","iconImage":"styles-module__iconImage___1fhbK"};